import PortalIdParser from 'PortalIdParser';
export const HELP_DESK_URL = `/help-desk/${PortalIdParser.get()}`;